import { render, staticRenderFns } from "./ReviewQuicktable.vue?vue&type=template&id=5206b3dd&"
import script from "./ReviewQuicktable.vue?vue&type=script&lang=js&"
export * from "./ReviewQuicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports